<template>
    <CButton
        :icon="hasPublishedMentor ? 'edit' : undefined"
        :variant="hasPublishedMentor ? 'primary-150' : 'secondary'"
        @click.prevent="makeAction"
    >
        <slot />
    </CButton>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useModal } from 'vue-final-modal'
import SignInModalContent from '@/components/modals/SignInModalContent.vue'

const props = defineProps<{
    to: any
    hasPublishedMentor: boolean
}>()

const router = useRouter()
const store = useApplicationStore()

// Setup modal
const { open: openSignInModal } = useModal({
    component: SignInModalContent
})

const loggedIn = computed((): boolean => {
    return store.APPLICATION_LOGGED_IN
})

const makeAction = () => {
    if (loggedIn.value) {
        router.push(props.to)
    } else {
        openSignInModal()
    }
}
</script>
